<template>
  <section v-on:click="sectionClicked">
    <Header :class="{scrolled: isScrolled}" ref="header"
      menu="teamUp"/>
    <div class="registerCnt" v-if="initialized">
      <div class="signInCnt" :class="{register: type === 'register'
        && regState !== 0 && regState !== 7}">
        <div class="backBtn" v-if="type === 'register' && regState !== 7
          && regState !== 0"
          v-on:click="back"></div>
        <div v-if="type === 'login'">
          <h3>Masuk</h3>
          <h4>Masuk ke Team Up For Impact.</h4>
        </div>
        <div class="forgotHeader" v-else-if="type === 'forgot'">
          <h3>Lupa Password</h3>
          <h4 v-if="emailSent">Link ganti password sudah terkirim.</h4>
          <h4 v-else>Kami akan mengirimkan link untuk ganti password ke
            <a href="#">{{theEmail}}</a>,
            ikuti petunjuk yang kami kirimkan untuk mengganti password.</h4>
        </div>
        <div v-else-if="regState === 0">
          <h3>Daftar</h3>
          <h4>Masukan alamat email pribadi kamu untuk melanjutkan.</h4>
          <div class="dbsInfo">
            <p>Hijaukan bulan kemerdekaan Indonesia dengan menanam pohon di hutan
              tanpa harus ke hutan melalui DBS Indonesia Sustainability Challenge.</p>
            <p>Ikuti semua misi yang ada di Team Up For Impact Everyday tiap harinya.
              Dapatkan 100 poin untuk setiap misi yang kamu ikuti dan 100 poin tambahan
              apabila kamu share misi kamu ke media sosial. Saat kamu mencapai 1400 poin,
              akan ada pohon yang ditanam di hutan atas nama kamu.</p>
            <p>Kumpulkan poin sebanyak-banyaknya, hijaukan hutan kita,
              dan raih hadiah total 10 juta rupiah untuk peraih poin terbanyak!</p>
          </div>
        </div>
        <div v-else-if="regState === 1">
          <h3>Verifikasi
            <span v-if="regType === 'email'">Email</span>
            <span v-else>No. Telp.</span>
          </h3>
          <h4>Kita telah mengirimkan kode verifikasi ke
            <span v-if="regType === 'email'">Email</span>
            <span v-else>No. Telp.</span> kamu<span
            v-if="regType === 'phone'"> melalui WhatsApp</span>.</h4>
        </div>
        <div v-else-if="regState === 2">
          <h3>Informasi Pribadi</h3>
          <h4>Masukan Staff ID dan password untuk akun baru.</h4>
        </div>
        <div v-else-if="regState === 3">
          <h3>Buat Password</h3>
          <h4>Buat password baru minimal 8 karakter untuk kamu masuk.</h4>
        </div>
        <div v-else-if="regState === 7">
          <h3>Daftar</h3>
          <h4>Masukan No. Telepon untuk melanjutkan.</h4>
        </div>
        <div class="forgotCnt" v-if="type === 'forgot'">
          <button class="cancelBtn" v-on:click="type = 'login'"
            v-if="!sendingEmail">Kembali</button>
          <button :class="{okBtn: 1, disabled: sendingEmail}"
            v-on:click="doForgotPwd">
            <span v-if="sendingEmail">Mengirimkan link...</span>
            <span v-else-if="emailSent">Kirim Ulang</span>
            <span v-else>Kirimkan Link</span>
          </button>
        </div>
        <form v-on:submit.prevent="handleSubmit" v-else>
          <div class="theEmail" v-if="theEmail && loginState === 'pwd'">
            <h4>{{theEmail}}</h4>
            <div class="chEmail" v-on:click="loginState = 'email'">Ganti pengguna</div>
          </div>
          <div v-if="type === 'login' && loginState === 'email'"
            :class="{fieldGroup: true, hasError: form.poe.error}">
            <input type="text" v-model="form.poe.model" class="field"
            placeholder="Email / No. Telp." v-on:input="fieldChanged('poe')">
            <div class="fieldError" v-if="form.poe.error">
              {{form.poe.error}}
            </div>
          </div>
          <div v-else-if="type !== 'login' && regState === 0"
            :class="{fieldGroup: true, hasError: form.email.error}">
            <input type="text" v-model="form.email.model" class="field"
            placeholder="Email" v-on:input="fieldChanged('email')">
            <div class="fieldError" v-if="form.email.error">
              {{form.email.error}}
            </div>
          </div>
          <div :class="{fieldGroup: true, hasError: form.pwd.error}"
            v-if="type === 'login' && loginState === 'pwd'">
            <div class="fieldCnt">
              <input :type="form.pwd.type" class="field" placeholder="Password"
                v-model="form.pwd.model" v-on:input="fieldChanged('pwd')"
                ref="pwd">
              <div :class="{showPwd: true, show: form.pwd.type === 'text'}"
                v-on:click="form.pwd.type = (form.pwd.type === 'text') ? 'password' : 'text'"></div>
            </div>
            <div class="fieldError" v-if="form.pwd.error">
              {{form.pwd.error}}
            </div>
          </div>
          <div v-if="type === 'register'">
            <div :class="{fieldGroup: true, hasError: form.code.error}"
              v-if="regState === 1">
              <input type="number" class="field otp" placeholder="Kode Verifikasi"
                v-model="form.code.model" v-on:input="fieldChanged('code')">
              <p class="hint">Masukan kode yang kami kirimkan.</p>
              <div class="fieldError" v-if="form.code.error">
                {{form.code.error}}
              </div>
            </div>
            <div v-else-if="regState === 2">
              <div :class="{fieldGroup: true, hasError: form.stafId.error}">
                <input type="text" class="field" placeholder="ID Staf..."
                  v-model="form.stafId.model" v-on:input="fieldChanged('stafId')">
                <div class="fieldError" v-if="form.stafId.error">
                  {{form.stafId.error}}
                </div>
              </div>
              <div class="fieldGroup">
                <div class="fieldCnt" v-if="1>2">
                  <input type="email" class="field" placeholder="Alamat email"
                    v-model="form.email.model">
                </div>
              </div>
              <div :class="{fieldGroup: true, hasError: form.pwd.error}">
                <div class="fieldCnt">
                  <input :type="form.pwd.type" class="field" placeholder="Password..."
                    v-model="form.pwd.model" v-on:input="fieldChanged('pwd')">
                  <div :class="{showPwd: true, show: form.pwd.type === 'text'}"
                    v-on:click="form.pwd.type = (form.pwd.type === 'text') ?
                    'password' : 'text'"></div>
                </div>
                <div class="fieldError" v-if="form.pwd.error">
                  {{form.pwd.error}}
                </div>
              </div>
            </div>
            <div v-else-if="regState === 7">
              <div :class="{fieldGroup: true, hasError: form.phone.error}">
                <div class="fieldCnt hasPrefix">
                  <input type="tel" class="field" placeholder="No. Telp."
                    v-model="form.phone.model" v-on:input="fieldChanged('phone')">
                  <div class="prefix">+62</div>
                </div>
                <div class="fieldError" v-if="form.phone.error">
                  {{form.phone.error}}
                </div>
              </div>
            </div>
          </div>
          <div class="forgotPwd" v-if="type === 'login' && loginState === 'pwd'"
            v-on:click="type = 'forgot'">
            Lupa password?</div>
          <div class="btnCnt">
            <button :class="{loading: loading}">
              <span v-if="type === 'login'">Masuk</span>
              <span v-else-if="regState === 2">Selesaikan Pendaftaran</span>
              <span v-else>Daftar</span>
            </button>
          </div>
          <div class="clear"/>
          <div class="regWithEmailCnt">
            <div class="otherMethod">Sudah punya akun?</div>
            <div class="reg regWithEmail" v-on:click="openLogin">
              <span>Masuk Disini</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'registerDbs',
  components: { Header },
  data() {
    return {
      isScrolled: false,
      initialized: false,

      type: 'register',
      regState: 0,
      regType: 'phone',
      loading: false,
      loginState: 'email',
      sendingEmail: false,
      emailSent: false,
      theEmail: '',
      form: {
        email: { model: '', error: null },
        poe: { model: '', error: null },
        pwd: { model: '', error: null, type: 'password' },
        code: { model: '', error: null },
        name: { model: '', error: null },
        phone: { model: '', error: null },
        stafId: { model: '', error: null },
      },
    };
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.closeSearch();
    },
    scrolled() {
      this.isScrolled = window.scrollY > 30;
    },
    back() {
      if (this.regState === 0) {
        this.regState = 7;
      } else if (this.regState === 7) {
        this.type = 'login';
      } else if (this.regType === 'phone') {
        this.regState = 7;
      } else {
        this.regState -= 1;
      }
    },
    openLogin() {
      if (!this.$refs.header) return;
      this.$refs.header.login({
        isDbs: true,
      });
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
    regNowEmail() {
      this.loading = true;
      this.$http.post(this.$config.uri('user/register/finish/email'), {
        isDbs: true,
        email: this.form.email.model,
        code: this.form.code.model,
        stafId: this.form.stafId.model,
        name: this.form.stafId.model,
        phone: this.form.phone.model,
        pwd: this.form.pwd.model,
      }).then((response) => {
        if (response.status !== 200) {
          this.loading = false;
          this.name.error = 'Internal server error.';
          return;
        }
        this.form.poe.model = this.form.email.model;
        setTimeout(() => {
          this.loginNow();
        });
      });
    },
    regNowPhone() {
      this.loading = true;
      this.$http.post(this.$config.uri('user/register/finish/phone'), {
        isDbs: true,
        stafId: this.form.stafId.model,
        email: this.form.email.model,
        code: this.form.code.model,
        name: this.form.stafId.model,
        phone: this.form.phone.model,
        pwd: this.form.pwd.model,
      }).then((response) => {
        if (response.status !== 200) {
          this.loading = false;
          this.name.error = 'Internal server error.';
          return;
        }
        this.form.poe.model = this.form.phone.model;
        setTimeout(() => {
          this.loginNow();
        });
      });
    },
    doForgotPwd() {
      if (this.sendingEmail) return;
      this.sendingEmail = true;
      this.$http.post(this.$config.uri('user/forgot/pwd'), {
        email: this.theEmail,
      }).then((response) => {
        this.sendingEmail = false;
        this.emailSent = true;
      });
    },
    verifyEmail(email, code, next) {
      this.$http.post(this.$config.uri('user/verify/email'), {
        email, code,
      }).then((response) => {
        next(response.data);
      });
    },
    verifyPhone(phone, code, next) {
      this.$http.post(this.$config.uri('user/verify/phone'), {
        phone, code,
      }).then((response) => {
        next(response.data);
      });
    },
    regEmail(email, next) {
      this.$http.post(this.$config.uri('user/register/email'), { email }).then((r) => {
        next(r.data);
      });
    },
    regPhone(phone, next) {
      this.$http.post(this.$config.uri('user/register/phone'), { phone }).then((r) => {
        next(r.data);
      });
    },
    poe(email, next) {
      this.$http.post(this.$config.uri('user/verify/poe'), { user: email }).then((r) => {
        if (r.data.status === 200) {
          this.theEmail = r.data.poe;
        } else if (r.data.notVerified) {
          this.loading = false;
          this.type = 'register';
          this.regType = r.data.type;
          this.regState = 1;
          if (this.regType === 'email') this.form.email.model = email;
          else this.form.phone.model = email;
          return;
        }
        next(r.data.status === 200);
      });
    },
    loginNow() {
      this.$http.post(this.$config.uri('user/signin'), {
        user: this.form.poe.model,
        password: this.form.pwd.model,
      }).then((response) => {
        if (response.data.status !== 200) {
          this.form.pwd.error = 'Password yang kamu masukan salah.';
          return;
        }

        this.$session.start();
        this.$session.set('tufi2_name', response.data.user.name);
        this.$session.set('tufi2_email', response.data.user.email);
        this.$session.set('tufi2_phone', response.data.user.phone);
        this.$session.set('tufi2_role', response.data.user.role);
        this.$session.set('tufi2_avatar', response.data.user.avatar);
        this.$session.set('tufi2_jwt', response.data.token);
        this.$session.set('tufi2_point', response.data.user.point);
        this.$session.set('tufi2_acc_bot', response.data.user.accBot);
        if (this.fromGame) localStorage.setItem('tufi2_welcome', 'ax02_s');
        window.location.reload();
      });
    },
    handleSubmit() {
      if (this.loading) return;
      if (this.type === 'login') {
        if (this.loginState === 'email') {
          if (this.form.poe.model === '') {
            this.form.poe.error = 'Mohon masukan Email / No. Telp. kamu.';
            return;
          }
          this.loading = true;
          this.poe(this.form.poe.model, (result) => {
            this.loading = false;
            if (!result) {
              this.form.poe.error = 'Email / No. Telp tidak derdaftar.';
              return;
            }
            this.loginState = 'pwd';
            setTimeout(() => {
              this.$refs.pwd.focus();
            });
          });
        } else {
          this.loginNow();
        }
      } else {
        switch (this.regState) {
          case 0:
            if (this.form.email.model === '') {
              this.form.email.error = 'Mohon masukan alamat email kamu.';
              return;
            }
            this.loading = true;
            this.regEmail(this.form.email.model, (result) => {
              this.loading = false;
              if (result.status !== 200) {
                this.form.email.error = result.message;
                return;
              }
              this.regType = 'email';
              this.regState = 1;
            });
            break;
          case 7:
            if (this.form.phone.model === '') {
              this.form.phone.error = 'Mohon masukan No. Telp. kamu.';
              return;
            }
            this.loading = true;
            this.regPhone(this.form.phone.model, (result) => {
              this.loading = false;
              if (result.status !== 200) {
                this.form.phone.error = result.message;
                return;
              }
              this.regType = 'phone';
              this.regState = 1;
            });
            break;
          case 1:
            if (this.form.code.model === '') {
              this.form.code.error = 'Mohon masukan kode verifikasi.';
              return;
            }
            this.loading = true;
            if (this.regType === 'phone') {
              this.verifyPhone(this.form.phone.model, this.form.code.model, (result) => {
                this.loading = false;
                if (result.status !== 200) {
                  this.form.code.error = 'Kode verifikasi salah.';
                  return;
                }
                this.regState += 1;
              });
            } else {
              this.verifyEmail(this.form.email.model, this.form.code.model, (result) => {
                this.loading = false;
                if (result.status !== 200) {
                  this.form.code.error = 'Kode verifikasi salah.';
                  return;
                }
                this.regState += 1;
              });
            }
            break;
          case 2:
            if (this.form.stafId.model === '') {
              this.form.stafId.error = 'Mohon masukan ID Staf kamu.';
              return;
            }
            // if (this.form.name.model === '') {
            //   this.form.name.error = 'Mohon masukan nama kamu.';
            //   return;
            // }
            if (this.form.pwd.model.length < 8) {
              this.form.pwd.error = 'Password minimal 8 karakter.';
              return;
            }
            if (this.regType === 'email') this.regNowEmail();
            else this.regNowPhone();
            break;
          default: break;
        }
      }
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Register - Team Up For Impact';

    if (this.$session.get('tufi2_jwt')) {
      window.location.href = '/team-up-everyday/play';
    } else {
      this.initialized = true;
    }
  },
};
</script>

<style scoped lang="scss">
.fieldGroup{
  text-align: left;
  .field.otp{
    text-align: center;
  }
}

.dbsInfo{
  margin: 0 -200px;
  padding: 0 0 20px;
  @media (max-width: 780px) {
    margin: 0 -100px;
  }
  @media (max-width: 620px) {
    margin: 0;
  }
  p{
    margin: 0 0 10px;
  }
}

.registerCnt{
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 120px;
  @media (max-width: 960px) {
    padding-top: 60px;
  }
  @media (max-height: 640px) {
    display: block;
    padding: 180px 0 40px;
  }
  .signInCnt{
    width: 320px;
    margin: -30px auto 0;
    text-align: center;
    @media (max-width: 620px) {
      width: auto;
      margin: -30px 20px 0;
    }
    .logo{
      height: 34px;
    }
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-image: url(../assets/arrow-back.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .2s ease;
      margin-left: -8px;
      opacity: .7;
      &:hover{
        background-color: #eee;
        opacity: 1;
      }
    }
    h3{
      font-size: 30px;
      font-weight: normal;
      font-weight: 600;
      margin: 0 0 4px;
      line-height: 1.2;
    }
    h4{
      font-weight: normal;
      margin: 0 0 20px;
      color: #767676;
      line-height: 1.2;
    }
    .forgotHeader{
      text-align: left;
      h3{
        margin-bottom: 10px;
      }
      h4{
        color: #444;
        font-size: 17px;
      }
    }
    .forgotCnt{
      text-align: right;
      button{
        height: 44px;
        border: none;
        border-radius: 5px;
        padding: 0 16px;
        font-size: 17px;
        font-weight: bold;
        box-sizing: border-box;
        cursor: pointer;
        outline: 0;
        transition: all .3s ease;
        color: #444;
        background-color: #fff;
        &:hover{
          background-color: #eee;
        }
        &.okBtn{
          margin-left: 10px;
          background-color: #5351a4;
          color: #fff;
          &:hover{
            background-color: #615fb1;
            box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.3);
          }
          &.disabled{
            background-color: #ddd;
            color: #999;
            box-shadow: none !important;
            cursor: default;
          }
        }
      }
    }
    form{
      .theEmail{
        margin: -10px 0 16px;
        h4{
          margin: 0;
          border: #a9e4ee 1px solid;
          padding: 4px 10px;
          border-radius: 50px;
          display: inline-block;
          line-height: 1.2;
          color: #555;
          background-color: #f4feff;
        }
        .chEmail{
          color: #615fb1;
          font-weight: 500;
          width: 120px;
          padding: 2px 0;
          margin: 5px auto;
          border-radius: 50px;
          cursor: pointer;
          &:hover{
            background-color: #eee;
          }
        }
      }
      .forgotPwd{
        font-size: 15px;
        color: #615fb1;
        margin-top: -8px;
        cursor: pointer;
        margin-bottom: 8px;
        text-align: left;
        padding-left: 7px;
        font-weight: 500;
        &:hover{
          color: #615fb1;
        }
      }
      .btnCnt{
        padding-top: 16px;
        padding-top: 6px;
        text-align: right;
        button{
          display: block;
          width: 100%;
          box-sizing: border-box;
          background-size: 30px auto;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 3px;
          &.loading{
            background-image: url(../assets/loading.svg);
            background-color: #ccc;
            border-color: #ccc;
            color: #999;
            box-shadow: none;
            cursor: default;
            span{
              visibility: hidden;
            }
          }
        }
      }
      .regWithEmailCnt{
        padding-top: 16px;
        text-align: left;
        font-size: 15px;

        text-align: center;
        .otherMethod{
          text-align: center;
        }
      }
      .reg{
        line-height: 1.2;
        padding-top: 14px;
        color: #5351a4;
        text-align: center;
        cursor: pointer;
        &.regWithEmail{
          border-radius: 3px;
          color: #444;
          // border: #eee 1px solid;
          // box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
          font-size: 16px;
          padding: 12px 0;
          margin-top: 6px;
          text-align: left;
          // padding-left: 44px;
          position: relative;
          transition: all .3s ease;

          border: #5351a4 2px solid;
          color: #5351a4;
          font-weight: 600;
          border-radius: 50px;
          display: inline-block;
          width: auto;
          text-align: center;
          margin-top: 10px;
          padding: 10px 24px;
          &:hover{
            // color: #444;
            background-color: #5351a4;
            color: #fff;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
          }
          &:before{
            // content: "";
            // position: absolute;
            // left: 12px; top: 0; bottom: 0;
            // width: 20px;
            // background-image: url(../assets/envelope-2.png);
            // background-size: 20px auto;
            // background-position: center;
            // background-repeat: no-repeat;
          }
          &.regWithGoogle{
            &:before{
              background-image: url(../assets/google-logo.png);
            }
          }
          &.regWithFacebook{
            &:before{
              background-image: url(../assets/fb-logo.png);
            }
          }
          &.regWithTwitter{
            &:before{
              background-image: url(../assets/twitter-logo.png);
            }
          }
        }
        &:hover{
          color: #615fb1;
        }
      }
      .socialSignIn{
        text-align: center;
        p{
          color: #767676;
          font-size: 15px;
        }
        button{
          background-color: #fff;
          height: 44px;
          color: #444;
          border: none;
          border-radius: 5px;
          padding: 0 14px;
          font-size: 16px;
          font-weight: bold;
          display: block;
          width: 100%;
          box-sizing: border-box;
          margin-bottom: 10px;
          box-shadow: 1px 1px 5px rgba(0,0,0,.1);
          text-align: left;
          padding-left: 50px;
          position: relative;
          cursor: pointer;
          outline: 0;

          opacity: .6;
          filter: grayscale(1);
          box-shadow: none !important;
          background-color: #eee;
          margin-bottom: 3px;
          cursor: default;
          span{
            float: right;
            color: #767676;
          }

          &:hover{
            box-shadow: 1px 1px 5px rgba(0,0,0,.2);
          }
          &:before{
            width: 26px; height: 26px;
            position: absolute;
            content: "";
            display: block;
            left: 12px; top: 9px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
    }
    &.register{
      padding-bottom: 20px;
      form{
        .btnCnt{
          padding-top: 6px;
        }
      }
    }
  }
}
</style>
